module.exports = __webpack_public_path__ + "img/blueBg.5cce8fb9.png";